(ns frontend.view.settings2.reporting-db.sub
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::new-password
 (fn [db]
   (get db ::new-password)))

(rf/reg-sub
 ::current-password
 (fn [db]
   (get db ::current-password)))

(rf/reg-sub
 ::new-pw-error
 :<-
 [::new-password]
 (fn [new-pw]
   (let [len (count (cu/str-trim new-pw))]
     (when (pos? len)
       (cond
         (not (re-find #"[a-z]" new-pw))
         (loc/tr :password/no-lower-case-characters-a-to-z)
         (not (re-find #"[A-Z]" new-pw))
         (loc/tr :password/no-upper-case-characters-A-to-Z)
         (not (re-find #"[0-9]" new-pw))
         (loc/tr :password/no-digits)
         (not (re-find #"[!@#$%^&*()=-]" new-pw))
         (loc/tr :password/no-special-characters ["!@#$%^&*()=-"])
         (< len 8)
         (loc/tr :password/too-short ["8"] [8])
         (> len 16)
         (loc/tr :password/too-long ["16" (str len)]))))))


(rf/reg-sub
 ::processing
 (fn [db]
   (get db ::processing)))
